import { AnimatePresence, motion } from 'framer-motion';
import { Box, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import CustomSpinner from '../../../../commonComponents/CustomSpinner';
import { ProfessionalHubRedesign } from '../../../../constants/ff.posthog';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { Colors } from '../../../../themes/colors';
import { CardActionsHeader } from '../CardActionsHeader';
import { EmptyFilteredList } from '../EmptyFilteredList';
import { ProfessionalCard } from '../ProfessionalCard';
import { EmptyFavorites } from './EmptyFavorites';
// New design
import { ProfessionalCardDetailsNew } from './ProfessionalCardDetailsNew';
import { ProfessionalCardActionsNew } from './ProfessionalCardActionsNew';
// Legacy design
import { ProfessionalCardDetails as ProfessionalCardDetailsLegacy } from './ProfessionalCardDetails';
import { ProfessionalCardActions as ProfessionalCardActionsLegacy } from './ProfessionalCardActions';
import { useFavoritesList } from './hooks/useFavoritesList';

export const FavoritesList = () => {
  const isNewDesign = useFeatureFlag(ProfessionalHubRedesign);
  const { isLoading, favoriteProfessionals, isEmpty, isFiltered } = useFavoritesList();

  if (isLoading) {
    return <CustomSpinner isLoading size={24} />;
  }

  if (isEmpty) {
    if (isFiltered) {
      return <EmptyFilteredList />;
    }
    return <EmptyFavorites />;
  }

  // Legacy design (feature flag OFF)
  if (!isNewDesign) {
    return (
      <div
        style={{
          width: '100%',
        }}
      >
        <span
          style={{
            display: 'flex',
            fontFamily: 'Nunito',
            fontSize: '16px',
            fontStyle: 'italic',
            color: Colors.neutral_500,
            textAlign: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          You can manage your list of favorite professionals on this section of the Professionals Hub,
          <br />
          and directly invite them to your upcoming shifts!
        </span>

        <div
          style={{
            maxWidth: '827px',
            marginTop: 32,
            display: 'flex',
            justifyContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <motion.div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 24,
            }}
            layout
          >
            <AnimatePresence>
              <CardActionsHeader actions={['Invite']} />
              {favoriteProfessionals?.map((professional) => (
                <ProfessionalCard
                  key={professional.id}
                  user={{
                    ...professional,
                    isFavorite: true,
                    rating: !professional?.averageProfessionalRating
                      ? undefined
                      : {
                          averageRating: professional?.averageProfessionalRating?.averageRating,
                          interpersonalSkills:
                            professional?.averageProfessionalRating?.averageInterpersonalSkills,
                          professionalSkills:
                            professional?.averageProfessionalRating?.averageProfessionalSkills,
                          timeManagement:
                            professional?.averageProfessionalRating?.averageTimeManagement,
                        },
                  }}
                  Details={ProfessionalCardDetailsLegacy}
                  Actions={ProfessionalCardActionsLegacy}
                  showRemoveIcon
                />
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    );
  }

  // New design (feature flag ON)
  return (
    <Box width="100%">
      <Typography italic color={colors.neutral[500]}>
        You can manage your list of favorite professionals on this section of the Professionals Hub,
        and directly invite them to your upcoming shifts!
      </Typography>

      <div
        style={{
          width: '100%',
          marginTop: 16,
          height: 600,
          overflowX: 'hidden',
          overflowY: 'auto',
          paddingRight: 8,
          paddingLeft: 2,
          paddingBottom: 20,
        }}
      >
        <motion.div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
          }}
          layout
        >
          <AnimatePresence>
            <CardActionsHeader actions={['Invite']} isNewDesign rightOffset={52} />
            {favoriteProfessionals?.map((professional) => (
              <ProfessionalCard
                key={professional.id}
                user={{
                  id: professional.id,
                  fullname: professional.fullname,
                  professions: professional.professions,
                  profession: professional.professions?.[0],
                  profileImage: professional.profileImage,
                  isAvailable: professional.isAvailable ?? true,
                  isFavorite: true,
                  yearsOfExperience: professional.yearsOfExperience,
                  badges: professional.badges ?? [],
                  activityLevel: professional.activityLevel,
                  rating: !professional?.averageProfessionalRating
                    ? undefined
                    : {
                        averageRating: professional?.averageProfessionalRating?.averageRating,
                        interpersonalSkills:
                          professional?.averageProfessionalRating?.averageInterpersonalSkills,
                        professionalSkills:
                          professional?.averageProfessionalRating?.averageProfessionalSkills,
                        timeManagement:
                          professional?.averageProfessionalRating?.averageTimeManagement,
                      },
                }}
                Details={ProfessionalCardDetailsNew}
                Actions={ProfessionalCardActionsNew}
                isNewDesign
                isFavoriteCard
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </Box>
  );
};
